import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Container, Col, Row, Nav, NavItem } from "reactstrap";
import { Switch, Route, NavLink, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import FAQ from "./FAQ";
import Transaction from "./Transaction";
import Selling from "./Selling";
import Standard from "./Standard";
import Terms from "./Terms";
import Privacy from "./Privacy";
import Payment from "./Payment";
import MandiriCampaign from "./MandiriCampaign";
import FiestaPointCampaign from "./FiestaPointCampaign";
import GooddayCampaign from "./GooddayCampaign";
import BTNCampaign from "./BTNCampaign";
import KaFairCampaign from "./KaFairCampaign";
import TCFairCampaign from "./TCFairCampaign";
import Novembazaar from "./Novembazaar";
import RaffleHarbolkick from "./RaffleHarbolkick";
import VoucherHarbolkick from "./VoucherHarbolkick";
import SpinTheWheel from "./SpinTheWheel";
import LuckyPayDay from "./LuckyPayDay";
import Funtoystic from "./Funtoystic";
import GreenRaffle from "./GreenRaffle"
import ScrollToTop from "../ScrollToTop";
import { ModalLineInfo } from "../Modals";
import BankBCA from "./BankBCA"
import { doScrollSection, fetchFaqs } from "../../actions/menuAction";
import { thousandGroupSpacing } from "react-currency-format/lib/utils";
import FAQDetail from "./FAQ/FAQDetail";

class PageHelps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openDrawer: {
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.hash !== this.props.location.hash) {
      const selectedSubFaq = this.findSubFaqSlug();
      let faqState = this.state.openDrawer;
      if (selectedSubFaq) {
        faqState[`${selectedSubFaq.selectedMainSlug.replaceAll("-", "")}`] = true;
        this.handleScrollSection(selectedSubFaq.selectedIndex);

        this.setState({
          openDrawer: faqState
        })
      }
    }
  }

  componentDidMount() {
    const { location, fetchFaqs, faqs } = this.props;

    fetchFaqs()
      .then(({ value }) => {

        let arr = value.data

        let faqState = {}
        const selectedSubFaq = this.findSubFaqSlug();

        if (arr) {
          for (let i = 0; i < arr.length; i++) {
            let checkUrl = location.pathname.split('/')[2].replaceAll('-', '')
            if (checkUrl !== arr[i].slug.replaceAll("-", "")) {
              faqState[`${arr[i].slug.replaceAll("-", "")}`] = false
              if (selectedSubFaq) {
                faqState[`${selectedSubFaq.selectedMainSlug.replaceAll("-", "")}`] = true;
                this.handleScrollSection(selectedSubFaq.selectedIndex);
              }
            } else {
              faqState[`${arr[i].slug.replaceAll("-", "")}`] = true
            }
          }
          this.setState({
            openDrawer: faqState
          })
        }

      })
      .catch(e => console.log(e))

    if (location.pathname === "/helps/events-partnership") {
      this.setState({
        isPartnerExpanded: true
      });
    }
  }

  _onToggle = () => {
    this.setState({
      modalLineOpen: !this.state.modalLineOpen
    });
  };

  updateState = (key, val, unselectable = false) => {
    this.handleScrollSection("");

    let drawerSelector = this.state.openDrawer

    drawerSelector[`${key}`] = val

    this.setState({
      opendrawer: drawerSelector //clear if the value is already selected
    })
  }

  handleScrollSection = name => {
    this.props.doScrollSection(name);
  };

  findSubFaqSlug = () => {
    let selectedIndex = '';
    let selectedData = {};
    let selectedMainSlug = '';
    const subFaqSlug = this.props.location.hash && this.props.location.hash.split('#')[1];
    for (let index = 0; index < this.props.faqs.length; index++) {
      const selected = this.props.faqs[index].faq.find(t => t.question.toLowerCase().split(' ').join('-') === subFaqSlug);
      if (selected) {
        selectedIndex = this.props.faqs[index].faq.findIndex((v) => v === selected);
        selectedData = selected;
        selectedMainSlug = this.props.faqs[index].slug;
        return { selectedIndex, selectedData, selectedMainSlug };
      }
    }
  };

  render() {

    const generalFaq = this.props.faqs

    return (
      <Container fluid className={this.props.countdown_modal ? 'main-container page-container countdown-active' : 'main-container page-container'}>
        <ScrollToTop />
        <Row style={{ marginTop: '100px' }}>
          <Col xs={12} md={12} lg={3}>
            <div style={{ padding: "15px 25px" }}>
              <p className="title-faq">Frequently Asked Questions</p>
              {
                generalFaq && generalFaq.map((item, id) => (
                  <Row key={id} style={{ display: "block" }}>
                    <Col xs={12}>
                      <Row
                        onClick={() =>
                          this.updateState(
                            item.slug.replaceAll("-", ""),
                            !this.state.openDrawer[`${item.slug.replaceAll("-", "")}`]
                          )
                        }
                      >
                        <Col md={10} xs={10}>
                          <p style={{ cursor: "pointer" }} className="title-expand">{item.name}</p>
                        </Col>
                        <Col md={2} xs={2}>
                          {
                            item.faq.length > 0 &&
                            <span className="dropdown-icon">
                              <i
                                className={
                                  this.state.openDrawer[`${item.slug.replaceAll("-", "")}`]
                                    ? "fa fa-angle-up"
                                    : "fa fa-angle-down"
                                }
                              ></i>
                            </span>
                          }
                        </Col>
                      </Row>
                    </Col>
                    <Nav vertical id="navbar-helps">
                      {
                        this.state.openDrawer[`${item.slug.replaceAll("-", "")}`] && item.faq.map((faq, index) => (
                          <NavItem>
                            <NavLink
                              to={{
                                pathname: `/helps/${item.slug}`,
                                aboutProps: {
                                  name: `${faq.question.toLowerCase().replaceAll(" ", "-")}`
                                },
                                hash: faq.question.toLowerCase().replaceAll(" ", "-"),
                              }}
                              onClick={() => this.handleScrollSection(index)}
                              className="nav-link"
                              style={{ paddingLeft: "15px", paddingRight: "15px" }}
                            >
                              {
                                faq.question
                              }
                            </NavLink>
                          </NavItem>
                        ))
                      }
                    </Nav>
                  </Row>
                ))
              }
              <div className="contact-us">
                <p>For further information</p>
                <p>
                  Email us at{" "}
                  <a href="mailto:info@kickavenue.com">info@kickavenue.com</a>
                </p>
                <p>
                  or Message us on Whatsapp{" "}
                  <a href="https://api.whatsapp.com/send?phone=6281210005425" onClick={this._onToggle}>
                    +6281210005425
                  </a>
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} lg={9}>
            <Switch>
              {
                generalFaq && generalFaq.map((item, index) => {
                  return (
                    <Route exact path={`/helps/${item.slug}`} component={FAQ} />
                  )
                })
              }
              <Redirect exact from="/helps" to="/helps/general-faq" />
            </Switch>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  faqs: state.dataMenu.faqs.data,
  countdown_modal: state.dataMenu.countdown_modal,
})

const mapDispatchToProps = dispatch => ({
  doScrollSection: name => dispatch(doScrollSection(name)),
  fetchFaqs: () => dispatch(fetchFaqs())
});

export default connect(mapStateToProps, mapDispatchToProps)(PageHelps);
